import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_DEFAULTS, SITE } from '../utils/constants';

const SEO = ({
  title,
  description,
  imageUrl,
  imageAlt,
  canonicalUrl,
  schema,
  keywords,
  ogType = 'website',
  twitterHandle = null,
  preloadImages = [],
}) => {
  const baseUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

  const fullTitle = title ? `${title} | ${SEO_DEFAULTS.siteName}` : SEO_DEFAULTS.siteName;
  const fullDescription = description || SEO_DEFAULTS.defaultDescription;
  const fullImageUrl = (imageUrl
    ? `${SEO_DEFAULTS.siteUrl}/${imageUrl}`
    : SEO_DEFAULTS.defaultImage
  ).replace(/([^:])\/\//g, '$1/');
  const fullCanonicalUrl = (canonicalUrl || SEO_DEFAULTS.siteUrl).replace(/([^:])\/\//g, '$1/');

  return (
    <Helmet>
      <html lang={SITE.lang || 'es'} />
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonicalUrl} />

      {preloadImages.map((imgUrl) => {
        const rawImageUrl = imgUrl || '';
        const isAbsoluteImageUrl = /^(?:[a-z]+:)?\/\//i.test(rawImageUrl);
        const imageUrl = isAbsoluteImageUrl
          ? rawImageUrl
          : `${baseUrl}/${rawImageUrl.replace(/^\/+/, '')}`;
        const webpUrl = imageUrl.replace(/\.(jpg|jpeg|png)$/i, '.webp');
        return (
          <link
            key={webpUrl}
            rel="preload"
            as="image"
            href={webpUrl}
            type="image/webp"
            fetchPriority="high"
          />
        );
      })}

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={imageAlt || fullTitle} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:site_name" content={SEO_DEFAULTS.siteName} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:image:alt" content={imageAlt || fullTitle} />
      {twitterHandle && <meta name="twitter:creator" content={twitterHandle} />}

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
